export class ActionToken {
  static IActionRepository = Symbol("IActionRepository");
  static ActionUseCase = Symbol("ActionUseCase");
}
